class GulfCart {
  constructor() {
    this.drawer = document.getElementById('cart-drawer');
    this.overlay = document.getElementById('cart-overlay');
    if (!this.drawer) return;
    this._noteTimer = null;
    this.bind();
  }

  bind() {
    document.addEventListener('click', e => {
      if (e.target.closest('[data-cart-trigger]')) {
        e.preventDefault();
        this.open();
      }
      if (e.target.closest('[data-cart-close]')) {
        this.close();
      }
      if (e.target.closest('[data-cart-qty]')) {
        const btn = e.target.closest('[data-cart-qty]');
        this.updateQty(btn.dataset.key, parseInt(btn.dataset.qty, 10));
      }
    });

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && this.isOpen()) this.close();
    });

    document.addEventListener('submit', e => {
      if (e.target.closest('.product-main')) {
        e.preventDefault();
        this.addToCart(e.target.closest('.product-main'));
      }
    });

    document.addEventListener('input', e => {
      if (e.target.closest('[data-cart-note]')) {
        const val = e.target.closest('[data-cart-note]').value;
        clearTimeout(this._noteTimer);
        this._noteTimer = setTimeout(() => this.saveNote(val), 600);
      }
    });
  }

  isOpen() {
    return this.drawer.getAttribute('aria-hidden') === 'false';
  }

  async open() {
    await this.refresh();
    this.drawer.setAttribute('aria-hidden', 'false');
    this.overlay.classList.add('is-active');
    this.overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-open');
    this.drawer.querySelector('[data-cart-close]')?.focus();
  }

  close() {
    this.drawer.setAttribute('aria-hidden', 'true');
    this.overlay.classList.remove('is-active');
    this.overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-open');
  }

  async refresh() {
    try {
      const res = await fetch('/?sections=cart-drawer');
      const data = await res.json();
      const doc = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');

      const swapId = id => {
        const next = doc.getElementById(id);
        const curr = document.getElementById(id);
        if (next && curr) curr.innerHTML = next.innerHTML;
      };

      swapId('cart-drawer-body');
      swapId('cart-drawer-footer');
      document.dispatchEvent(new CustomEvent('cart:refreshed'));

      const countEl = doc.querySelector('[data-cart-count-value]');
      const count = countEl ? parseInt(countEl.textContent, 10) : 0;
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = count || '';
        el.hidden = count === 0;
      });
    } catch (err) {
      console.error('[GulfCart] refresh failed', err);
    }
  }

  async addToCart(productMain) {
    const form = productMain.querySelector('form');
    const btn = productMain.querySelector('.product-purchase__atc');
    const originalText = btn?.textContent.trim();

    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

    try {
      const formData = new FormData(form);
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData
      });
      if (!res.ok) throw new Error('Add failed');
      this.open();
    } catch (err) {
      console.error('[GulfCart] add failed', err);
    } finally {
      if (btn) { btn.disabled = false; btn.textContent = originalText; }
    }
  }

  async updateQty(key, qty) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      await this.refresh();
    } catch (err) {
      console.error('[GulfCart] qty update failed', err);
    }
  }

  async saveNote(note) {
    try {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note })
      });
    } catch (err) {
      console.error('[GulfCart] note save failed', err);
    }
  }

}

document.addEventListener('DOMContentLoaded', () => { window.gulfCart = new GulfCart(); });
